<div class="guide-page mt-5">
    <div class="guide-shell">
        <aside class="guide-sidebar">
            <div class="sidebar-header">
                <p class="sub-title-modern">Technical Guide</p>
                <h2>Developer Documentation</h2>
            </div>

            <ul class="section-list">
                <ng-container *ngFor="let section of sections">
                    <li class="section-item" [class.active]="selectedSection === section.id && !selectedChild"
                        (click)="selectSection(section.id)">
                        <div class="section-meta">
                            <i [class]="section.icon"></i>
                            <span>{{ section.label }}</span>
                        </div>

                        <button *ngIf="section.children?.length" type="button" class="expand-btn"
                            (click)="toggleSection(section.id); $event.stopPropagation()">
                            {{ expandedSection === section.id ? '−' : '+' }}
                        </button>
                    </li>

                    <ul *ngIf="section.children?.length && expandedSection === section.id" class="child-list">
                        <li *ngFor="let child of section.children" class="child-item"
                            [class.active]="selectedSection === section.id && selectedChild === child.id"
                            (click)="selectSection(section.id, child.id); $event.stopPropagation()">
                            {{ child.label }}
                        </li>
                    </ul>
                </ng-container>
            </ul>
        </aside>

        <section class="guide-content">
            <div class="guide-view-header">
                <span class="sub-title-modern">Lemonmode API</span>
                <h1>{{ selectedSectionLabelWithChild }}</h1>
                <p class="subtitle">{{ selectedSectionDescription }}</p>
            </div>

            <div class="guide-panel" *ngIf="selectedSection === 'introduction' && selectedChild === 'overview'">
                <h3>Introduction</h3>
                <p>
                    Welcome, The purpose of Lemonmode API documentation is to help user understand and make use of API
                    calls to get tracking details for lemonmode tracking number.
                </p>
            </div>

            <div class="guide-panel" *ngIf="selectedSection === 'introduction' && selectedChild === 'authentication'">
                <h3>Authentication</h3>
                <p>
                    Making use of basic authentication, each request must include an authentication header, with a
                    base-64 encoded value. Credentials for basic authentication is provided via mail.
                </p>
                <div class="info-callout">
                    <strong>Code Example</strong>
                    <code>'Authorization: Basic [base64(username:password)]'</code>
                </div>
            </div>

            <div class="guide-panel" *ngIf="selectedSection === 'introduction' && selectedChild === 'throttling'">
                <h3>Throttling Limit</h3>
                <p>Throttle limit of API call is 25 hits per min.</p>
            </div>

            <div class="guide-panel" *ngIf="selectedSection === 'apis' && selectedChild === 'tracking-details'">
                <h3>Get Tracking Details</h3>
                <p>This call help us to retrieve all tracking details with respect to Lemonmode tracking Id or Order
                    Number.</p>
                <p><b>Input parameters-</b> Lemonmode Tracking ID/ Order Number.</p>
                <p><b>Url end point-</b></p>
                <p><b>Sandbox-</b></p>
                <p>For Lemonmode Tracking number-</p>
                <p class="endpoint-link">http://{{ this.url }}/sandbox?tracking_number={{ '{' }}lemon mode tracking
                    number{{ '}' }}</p>
                <p>For Order number-</p>
                <p class="endpoint-link">http://{{ this.url }}/sandbox?order_id={{ '{' }}Order number{{ '}' }}</p>
                <p><b>Production-</b></p>
                <p>For Lemonmode Tracking number-</p>
                <p class="endpoint-link">http://{{ this.url }}/operations?tracking_number={{ '{' }}lemon mode tracking
                    number{{ '}' }}</p>
                <p>For Order number-</p>
                <p class="endpoint-link">http://{{ this.url }}/operations?order_id={{ '{' }}Order number{{ '}' }}</p>
                <p><b>Method-</b></p>
                <p>GET</p>

                <div class="redoc-state" *ngIf="specLoading">Loading API documentation...</div>
                <div class="redoc-state redoc-state-error" *ngIf="!specLoading && specLoadError">{{ specLoadError }}
                </div>
                <div class="redoc-embed" [class.is-hidden]="specLoading || specLoadError">
                    <div #redocContainer class="redoc-container"></div>
                </div>
            </div>

            <div class="guide-panel" *ngIf="selectedSection === 'apis' && selectedChild === 'tracking-status'">
                <h3>Tracking Status Description</h3>
                <div class="table-wrap">
                    <table class="status-table">
                        <thead>
                            <tr>
                                <th scope="col">Status</th>
                                <th scope="col">Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>LOC</td>
                                <td>Order Placed</td>
                            </tr>
                            <tr>
                                <td>LITU</td>
                                <td>Order Manifested</td>
                            </tr>
                            <tr>
                                <td>LRU</td>
                                <td>Shipment arrived at Hub</td>
                            </tr>
                            <tr>
                                <td>LTI</td>
                                <td>In Transit to India</td>
                            </tr>
                            <tr>
                                <td>LAE</td>
                                <td>Arrived at Europe Hub</td>
                            </tr>
                            <tr>
                                <td>LAI</td>
                                <td>Arrived in India</td>
                            </tr>
                            <tr>
                                <td>LUC</td>
                                <td>Under Custom Clearance</td>
                            </tr>
                            <tr>
                                <td>OP</td>
                                <td>Dispatched from Mumbai Hub</td>
                            </tr>
                            <tr>
                                <td>Dispatched</td>
                                <td>Order Dispatched</td>
                            </tr>
                            <tr>
                                <td>OT</td>
                                <td>Order in Transit</td>
                            </tr>
                            <tr>
                                <td>OO</td>
                                <td>Order Out for Delivery</td>
                            </tr>
                            <tr>
                                <td>NDR</td>
                                <td>OFailed Attempt at Delivery</td>
                            </tr>
                            <tr>
                                <td>DL</td>
                                <td>Order Delivered</td>
                            </tr>
                            <tr>
                                <td>RTO</td>
                                <td>Order Returned Back</td>
                            </tr>
                            <tr>
                                <td>RTO-OO</td>
                                <td>RTO out for delivery</td>
                            </tr>
                            <tr>
                                <td>RTP</td>
                                <td>RTO Reached Pickrr Warehouse</td>
                            </tr>
                            <tr>
                                <td>Booked</td>
                                <td>Order Booked</td>
                            </tr>
                            <tr>
                                <td>Manifested</td>
                                <td>Manifested</td>
                            </tr>
                            <tr>
                                <td>RTS</td>
                                <td>RTS</td>
                            </tr>
                            <tr>
                                <td>RTO-IT</td>
                                <td>RTO-In Transit</td>
                            </tr>
                            <tr>
                                <td>RTO-Pending</td>
                                <td>RTO Pending</td>
                            </tr>
                            <tr>
                                <td>RTO-Dispatched</td>
                                <td>RTO Dispatched</td>
                            </tr>
                            <tr>
                                <td>LOST</td>
                                <td>LOST</td>
                            </tr>
                            <tr>
                                <td>Delivered</td>
                                <td>Delivered</td>
                            </tr>
                            <tr>
                                <td>Cancelled</td>
                                <td>Cancelled</td>
                            </tr>
                            <tr>
                                <td>Picked</td>
                                <td>Picked</td>
                            </tr>
                            <tr>
                                <td>Pickup Pending</td>
                                <td>Pickup Pending</td>
                            </tr>
                            <tr>
                                <td>Failed</td>
                                <td>Failed</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="guide-panel" *ngIf="selectedSection === 'languages' && selectedChild === 'php'">
                <h3>PHP</h3>
                <div class="code-header">
                    <span>Code Example</span>
                    <button type="button" class="copy-btn" (click)="copyData(test)">
                        <i class="fa-solid fa-copy" title="Copy"></i>
                    </button>
                </div>
                <pre><code #test><?php
$curl = curl_init();
curl_setopt_array($curl, array(
CURLOPT_URL => 'http://{{this.url}}/operations?tracking_number=1710446256',
CURLOPT_RETURNTRANSFER => true,
CURLOPT_ENCODING => '',
CURLOPT_MAXREDIRS => 10,
CURLOPT_TIMEOUT => 0,
CURLOPT_FOLLOWLOCATION => true,
CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
CURLOPT_CUSTOMREQUEST => 'GET',
CURLOPT_HTTPHEADER => array(
'Authorization: Basic [base64(username:password)]'
),
));
$response = curl_exec($curl);
curl_close($curl);
echo $response;
?></code></pre>
            </div>

            <div class="guide-panel" *ngIf="selectedSection === 'languages' && selectedChild === 'java'">
                <h3>Java</h3>
                <div class="code-header">
                    <span>Code Example</span>
                    <button type="button" class="copy-btn" (click)="copyData(test1)">
                        <i class="fa-solid fa-copy" title="Copy"></i>
                    </button>
                </div>
                <pre><code #test1>OkHttpClient client = new OkHttpClient().newBuilder()
  .build();
Request request = new Request.Builder()
  .url("http://{{this.url}}/operations?tracking_number=1710446256")
  .method("GET", null)
  .addHeader("Authorization", "Basic [base64(username:password)]")
  .build();
Response response = client.newCall(request).execute();</code></pre>
            </div>

            <div class="guide-panel" *ngIf="selectedSection === 'languages' && selectedChild === 'python'">
                <h3>Python</h3>
                <div class="code-header">
                    <span>Code Example</span>
                    <button type="button" class="copy-btn" (click)="copyData(test2)">
                        <i class="fa-solid fa-copy" title="Copy"></i>
                    </button>
                </div>
                <pre><code #test2>import http.client
conn = http.client.HTTPSConnection("{{this.url}}")
payload = ""
headers = {{ '{' }}
  "Authorization": "Basic [base64(username:password)]"
  {{ '}' }}
conn.request("GET", "/operations?tracking_number=1710446256", payload, headers)
res = conn.getresponse()
data = res.read()
print(data.decode("utf-8"))</code></pre>
            </div>

            <div class="guide-panel" *ngIf="selectedSection === 'languages' && selectedChild === 'curl'">
                <h3>CURL</h3>
                <div class="code-header">
                    <span>Code Example</span>
                    <button type="button" class="copy-btn" (click)="copyData(test3)">
                        <i class="fa-solid fa-copy" title="Copy"></i>
                    </button>
                </div>
                <pre><code #test3>curl --location --request GET 'http://{{this.url}}/operations?tracking_number=1710446256' \
--header 'Authorization: Basic [base64(username:password)]'</code></pre>
            </div>

            <div class="guide-panel" *ngIf="selectedSection === 'languages' && selectedChild === 'http'">
                <h3>HTTP</h3>
                <div class="code-header">
                    <span>Code Example</span>
                    <button type="button" class="copy-btn" (click)="copyData(test4)">
                        <i class="fa-solid fa-copy" title="Copy"></i>
                    </button>
                </div>
                <pre><code #test4>GET /operations?tracking_number=1710446256 HTTP/1.1
Host: {{this.url}}
Authorization: Basic [base64(username:password)]</code></pre>
            </div>

            <div class="guide-panel" *ngIf="selectedSection === 'languages' && selectedChild === 'csharp'">
                <h3>C#</h3>
                <div class="code-header">
                    <span>Code Example</span>
                    <button type="button" class="copy-btn" (click)="copyData(test5)">
                        <i class="fa-solid fa-copy" title="Copy"></i>
                    </button>
                </div>
                <pre><code #test5>ar client = new RestClient('http://{{this.url}}/operations?tracking_number=1710446256');
client.Timeout = -1;
var request = new RestRequest(Method.GET);
request.AddHeader('Authorization', 'Basic [base64(username:password)]');
IRestResponse response = client.Execute(request);
Console.WriteLine(response.Content);</code></pre>
            </div>

        </section>
    </div>
</div>